import type { replyFailureTr } from './reply-failure.tr.js';

type Words<T> = { readonly [K in keyof T]: T[K] extends string ? string : Words<T[K]> };

/** English twin of reply-failure.tr.ts; the same keys. */
export const replyFailureEn: Words<typeof replyFailureTr> = {
  long: {
    title: 'This job is too long to write in one go.',
    file: 'Oppy tried to write all of {{file}} at once, but reached the limit of how much it can write in one reply. It worked for {{time}} and could not finish the file.',
    work: 'Oppy tried to finish the job at once, but reached the limit of how much it can write in one reply. It worked for {{time}} and could not finish.',
    workNoTime: 'Oppy tried to finish the job at once, but reached the limit of how much it can write in one reply and could not finish.',
    fileNoTime: 'Oppy tried to write all of {{file}} at once, but reached the limit of how much it can write in one reply and could not finish the file.',
    unchanged: 'Nothing changed in your workspace.',
    changed: 'The files written meanwhile are in your workspace.',
    adviceLead: 'What you can do:',
    advice: 'Split the job. Ask for a simple version first, then improve it step by step.',
  },
  empty: {
    title: 'Oppy could not answer this request.',
    tries: 'The model came back empty {{count}} times. This is usually temporary; try again in a few seconds.',
    once: 'The model came back empty. This is usually temporary; try again in a few seconds.',
    advice: 'If it keeps happening, try a shorter request or other words.',
  },
  actions: {
    simple: 'Start with a simple version',
    retry: 'Try again',
    details: 'Technical details',
    copy: 'Copy',
    copied: 'Copied',
    copyLabel: 'Copy the run number',
  },
  simplePrompt: 'Start with a simple version of this; we will improve it step by step.',
  labels: { what: 'What happened', tries: 'Tries', timeModel: 'Time and model', run: 'Run number' },
  what: {
    file: 'The model left its file write unfinished; it reached the length limit of one reply ({{limit}} tokens).',
    call: 'The model’s tool call was left unfinished; it reached the length limit of one reply ({{limit}} tokens).',
    thinking: 'The model reached the length limit of one reply ({{limit}} tokens) while thinking; it never got to writing.',
    empty: 'The model returned no visible text and no tool call.',
    unknown: 'The model did not produce an answer.',
  },
  tries: {
    allCut: '{{count}} tries, {{all}} cut at the same point',
    oneCut: '1 try, cut at the length limit',
    someCut: '{{count}} tries, {{cut}} cut at the length limit',
    allEmpty: '{{count}} tries, {{all}} came back empty',
    oneEmpty: '1 try, came back empty',
  },
  chip: { file: 'file left unfinished', limit: 'hit the length limit' },
  attempt: {
    thinking: 'Try {{n}}: hit the length limit while thinking',
    tool_call: 'Try {{n}}: hit the length limit while writing',
    empty: 'Try {{n}}: came back empty',
  },
  count: { 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight', 9: 'nine', 10: 'ten' },
  all: { 2: 'both', 3: 'all three', 4: 'all four', 5: 'all five', 6: 'all six', 7: 'all seven', 8: 'all eight', 9: 'all nine', 10: 'all ten' },
};
